module.exports = __webpack_public_path__ + "img/normal.6c5a1704.png";